import React, { Component } from "react"
import * as helpers from "../../helpers/sectionclasses"
// import Image from "gatsby-image"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

class LogoCarousel extends Component {
  render() {
    const content = this.props.content
    const sectionClasses = helpers.sectionClasses(content.sectionOptions)
    return (
      <section className={`${sectionClasses}`}>
        {content.title ? (
          <div className="container">
            <div className="lrg:px-6 tab:w-9/12">{content.title}</div>
          </div>
        ) : (
          ""
        )}
        <div className="hero-marquee absolute">
          <div className="marquee">
            <div className="clipped-images">
              <div className="logo-list">
                {content.logos.map((logo, index) => {
                  return logo.localFile?.childImageSharp ? (

                    <GatsbyImage 
                        key={index}
                        image={getImage(logo.localFile.childImageSharp)} 
                        className="w-full" 
                        alt={logo.altText} 
                        style={{
                          margin: "1rem 2rem",
                          width: "150px",
                          height: "65px",
                        }}
                        objectFit="contain"
                        loading="eager"
                        layout="fullWidth"
                    />
                  ) : (
                    ""
                  )
                })}
              </div>
            </div>
            <div className="clipped-images">
              <div className="logo-list">
                {content.logos.map((logo, index) => {
                  return logo.localFile?.childImageSharp ? (
                    <GatsbyImage 
                        key={index}
                        image={getImage(logo.localFile.childImageSharp)} 
                        className="w-full" 
                        alt={logo.altText} 
                        style={{
                          margin: "1rem 2rem",
                          width: "150px",
                          height: "65px",
                        }}
                        objectFit="contain"
                        loading="eager"
                        layout="fullWidth"
                    />


                  ) : (
                    ""
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default LogoCarousel